import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { VideoStreamType } from '@app/main/components/videos/enums/VideoStreamType';
import { CameraFootageService } from '@app/main/components/videos/services/camera-footage.service';
import { DateService } from '@app/services/date.service';
import './download-quality-selector.component.scss';

@Component({
    selector: 'download-quality-selector',
    template: require('./download-quality-selector.component.html')
})
export class DownloadQualitySelector {
    @Input() serial: string;
    @Input() startTime: Date;
    @Input() endTime: Date;

    @Output() qualityChange = new EventEmitter<VideoStreamType>();

    selectedStreamType: VideoStreamType;
    substreamAvailable: boolean;
    mainstreamAvailable: boolean;
    VideoStreamType = VideoStreamType;

    loading: boolean = true;
    
    constructor(
        private readonly cameraFootageService: CameraFootageService,
        private readonly dateService: DateService) { }

    ngOnChanges(changes: SimpleChanges): void {
            this.getAvailableQualities();
    }

    qualitySelected(quality: VideoStreamType): void {
        this.qualityChange.emit(quality);
    }

    //--

    private getAvailableQualities(): void {
        if (!this.serial || !this.startTime || !this.endTime) {
            return;
        }

        this.loading = true;

        this.cameraFootageService.getFootageHistoryForDay(this.serial, this.startTime).then(footage => {
            if (!footage?.length) {
                return;
            }

            const footageAtTime = footage.filter(ftg => {
                return this.dateService.dateIsBetweenDates(this.startTime, ftg.Start, ftg.End) || this.dateService.dateIsBetweenDates(this.endTime, ftg.Start, ftg.End);
            })

            const availableFootageTypes = footageAtTime.map(ftg => ftg.StreamType);

            if (availableFootageTypes.includes(VideoStreamType.Sub)) {
                this.substreamAvailable = true;
                this.selectedStreamType = VideoStreamType.Sub;
                
            }

            if (availableFootageTypes.includes(VideoStreamType.Main)) {
                this.mainstreamAvailable = true;
                this.selectedStreamType = VideoStreamType.Main;
            }

        }).finally(() => {
            this.loading = false;
        })
    }
}
